export default __webpack_public_path__ + "static/media/icon-step-four.5b4beffd.png";